import { render, staticRenderFns } from "./form-result-kplh.vue?vue&type=template&id=b92f0858&"
import script from "./form-result-kplh.vue?vue&type=script&lang=js&"
export * from "./form-result-kplh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports